import { render } from "./activities-list.vue?vue&type=template&id=691b7d9b"
import script from "./activities-list.vue?vue&type=script&lang=js"
export * from "./activities-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__